import { CollectionPageContents_collection, Visibility } from 'globalTypes'

import Buy from 'Root/App/Header/Buttons/Buy'

enum UserVisibility {
  NotLoggedPublic = 'NotLoggedPublic',
  LoggedPublic = 'LoggedPublic',
  LoggedProtected = 'LoggedProtected',
}

type CallToActionProps = {
  userID: string | undefined
  collection: CollectionPageContents_collection
}

/**
 *
 * @param userID ID representig the user that is visualizing the collection. Can be undefined for not registered users.
 * @param visibility Collection visibility. Can be one of @see Visibility
 *
 * @returns A string representing the user visibility status. Can be one of @see UserVisibility
 */
const getUserVisibility = (userID: string, visibility: Visibility) => {
  // notLoggedV1
  if (!userID && visibility === Visibility.public)
    return UserVisibility.NotLoggedPublic

  // studentV1
  if (userID && visibility === Visibility.public)
    return UserVisibility.LoggedPublic

  // studentV2
  return UserVisibility.LoggedProtected
}

/**
 * This Component shows call to action buttons based on the user registration status and collection visibility.
 *
 * @param userID  ID representig the user that is visualizing the collection. Can be undefined for not registered users.
 * @param collection Collection object properties.
 *
 * @returns Button components based on user registration status and collection visibility. @see UserVisibility for more info.
 */
const CallToAction = ({ userID, collection }: CallToActionProps) => {
  const userVisibility = getUserVisibility(userID, collection.visibility)
  const isCreator = userID === collection.creator.id
  const isSelling = collection.selling && collection.sellingPricing > 0

  if (isCreator) return null

  if (userVisibility === UserVisibility.NotLoggedPublic) {
    if (isSelling && !collection.need_registration) {
      return <Buy customClass="min-w-24" collection={collection} />
    }
  }

  if (userVisibility === UserVisibility.LoggedPublic && !collection.canRead) {
    if (isSelling && !collection.need_registration) {
      return <Buy customClass={'min-w-24'} collection={collection} />
    }
  }

  return null
}

export default CallToAction
